/*
*   File : portfolio-detail.js
*   Author : https://evoqins.com
*   Description : Portfolio detail page
*   Integrations : NA
*   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

//Custom components
import { Breadcrumbs, Chip, CustomTab, Loader } from '../../Component/Others';
import { Icon } from '../../Component/Icon';
import { PrimaryButton, SecondaryButton, TextButton } from '../../Component/Buttons';
import { APIService } from '../../Service';
import { _checkBrokerStatus, _createAndUpdatePortFolio, _executeBrokerOrder, _formattedAmount, _generateProductCode, _getBasketDetail, _getBrokersList, _getMarketStatus, _openBrokerOrderPlatform, _scrollToTop, _validateBroker, _validateBrokerOrder } from '../../Helper';
import { BROKERS_LIST_DATA } from '../../Helper';

//Styles
import style from "../../Styles/Component/portfolio.module.scss";
import { OrderStatusModal } from '../../Component/Modal';
import { Modal } from 'bootstrap';

// Custom data
const BREADCRUMBS = [
    {
        id: 1,
        label: "Portfolio",
        path: "/portfolio"
    },
];

const TAB_DATA = [
    {
        id: 1,
        label: "Stock Breakdown",
    },
    {
        id: 2,
        label: "Order History"
    },
];

const DEFAULT_SORT = {
    current_value: "ASC",
    invested_value: "ASC",
};


const PortfolioDetail = () => {

    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA);
    const navigate = useNavigate();
    const { state } = useLocation();
    const sortBy = useRef(DEFAULT_SORT);
    const orderStatusData = useRef();

    let connected_broker = JSON.parse(localStorage.getItem("indvestment_connected_broker"));

    const [basketData, setBasketData] = useState({});
    const [basketHoldings, setBasketHoldings] = useState([]);
    const [breadcrumbs, setBreadCrumbs] = useState(BREADCRUMBS);
    const [tabIndex, setTabIndex] = useState(state && state.id ? state.id : 1);
    const [portfolioData, setPortFolioData] = useState({});
    const [stockBreakDown, setStockBreakDown] = useState([]);
    const [orderData, setOrderData] = useState([]);
    const [expandedKey, setExpandedKey] = useState(-1);
    const [dataLoading, setDataLoading] = useState(true);
    const [orderDataLoading, setOrderDataLoading] = useState(true);
    const [btnLoader, setBtnLoader] = useState(false);
    const [redeemLoader, setRedeemLoader] = useState(false);
    const [isSIPDue, setIsSIPDue] = useState(false);
    // const [investMentData, setInvestmentData] = useState({});
    const [executedBroker, setExecutedBroker] = useState({});
    const [isSameBroker, setIsSameBroker] = useState(false);
    const [repairHoldings, setRepairHoldings] = useState([]);

    const [skipLoader, setSkipLoader] = useState(false);
    const [repairLoader, setRepairLoader] = useState(false);
    const [selectedRepairOrderId, setSelectedRepairOrderId] = useState(null);
    const [showOrderStatusModal, setShowOrderStatusModal] = useState(false);


    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();

        if (tabIndex == 2 && orderData && orderData.length === 0) {
            setOrderDataLoading(true);
            _getPortfolioOrderDetail();
        }
    }, [tabIndex]);

    useEffect(() => {
        if (state && state.product && state.product.portfolio_id) {
            _getPortfolioDetails();
        } else {
            // If we don't have id navigate to => listing page
            navigate("/portfolio");
        }
    }, []);

    useEffect(() => {
        if (portfolioData && portfolioData.strategy_id) {
            _getBasketDetail(portfolioData.strategy_id, USER_DATA.unique_identifier, portfolioData.creator_id).then(response => {
                if (response.status_code === 200) {
                    setBasketData(response.data);
                }
            });

            // Getting executed broker data
            _getBrokersList().then((response) => {
                if (response.status_code === 200) {
                    let executed_broker = response.data.find((broker) => broker.broker_name === portfolioData.execution_partner);
                    setExecutedBroker(executed_broker);
                }
            });

        }
    }, [portfolioData]);

    useEffect(() => {
        if (showOrderStatusModal) {
            const order_status_modal = new Modal(document.getElementById('order-status-modal'));
            order_status_modal.show();
        }
    }, [showOrderStatusModal]);

    // handle tab change
    const _handleTabChange = (id) => {
        navigate("/portfolio/detail", {
            state: {
                id: id,
                product: state.product
            }
        });

        setTabIndex(id);
    };

    // handle show 
    const _handleShowStockDetails = (key) => {
        if (key === expandedKey) {
            setExpandedKey(-1);
        } else {
            setExpandedKey(key);
        }
    };

    // handle navigate to invest page
    const _handleNavigateToInvest = () => {
        let action = "INVEST_MORE" // Redeem Action
        setBtnLoader(true);
        if (connected_broker && isSameBroker) {
            // Checking market status
            _callGetMarketStatus(action);
        } else {
            _handleConnectExecutedBroker(action);
        }
    };

    //handle navigate to redeem page
    const _handleNavigateToRedeem = () => {
        let action = "REDEEM" // Redeem Action
        setRedeemLoader(true);
        if (connected_broker && isSameBroker) {
            _callGetMarketStatus(action);
        } else {
            _handleConnectExecutedBroker(action);
        }
    };

    // handle navigate to manage sip 
    const _handleManageSIP = () => {
        navigate("/sip");
    };

    // handle navigate - breadcrumbs
    const _handleNavigate = (data) => {
        navigate(data.path);
    };

    // handle sort Stock Breakdown
    const _handleSortByCurrentValue = () => {

        if (sortBy.current.current_value === "ASC") {
            let sorted_breakdown = stockBreakDown.sort((item1, item2) => item1.current_value - item2.current_value);
            setStockBreakDown([...sorted_breakdown]);
            sortBy.current.current_value = "DSC"
        } else {
            let sorted_breakdown = stockBreakDown.sort((item1, item2) => item2.current_value - item1.current_value);
            setStockBreakDown([...sorted_breakdown]);
            sortBy.current.current_value = "ASC"
        }

    };

    // handle sort Stock Breakdown
    const _handleSortByInvestedValue = () => {

        if (sortBy.current.invested_value === "ASC") {
            let sorted_breakdown = stockBreakDown.sort((item1, item2) => item1.invested_amount - item2.invested_amount);
            setStockBreakDown([...sorted_breakdown]);
            sortBy.current.invested_value = "DSC"
        } else {
            let sorted_breakdown = stockBreakDown.sort((item1, item2) => item2.invested_amount - item1.invested_amount);
            setStockBreakDown([...sorted_breakdown]);
            sortBy.current.invested_value = "ASC"
        }

    };

    // handle navigate to rebalance details
    const _handleNavigateToRebalanceDetails = () => {
        if (connected_broker && isSameBroker) {
            navigate("rebalance", {
                state: {
                    basket_data: basketData,
                    portfolio_data: portfolioData,
                    executed_broker: executedBroker
                }
            });
        } else {
            let action = "REBALANCE";
            _handleConnectExecutedBroker(action);
        }
    };

    // handle skip rebalance 
    const _handleSkipRebalance = () => {
        // API call
        _skipRebalance();
    };

    // handle connect broker - connecting already executed broker
    const _handleConnectExecutedBroker = (action, selected_order_item) => {

        toast.dismiss();
        toast.error(`Please connect with the same broker, you used previously to place order (${portfolioData.execution_partner})`);

        // Open broker connect window
        setTimeout(() => {
            let broker_connect_window = window.open(executedBroker.url, "_blank");
            let access_token = "";
            let interval = setInterval(() => {
                try {
                    let current_url = broker_connect_window.location.href;
                    let url_data = current_url.split('?');
                    if (url_data.length !== 1) {
                        // Taking the token from the URL
                        let params = new URLSearchParams(url_data[1]);
                        let access_token_name = BROKERS_LIST_DATA.find(broker => broker.broker_name === executedBroker.broker_name).access_token_name;
                        access_token = params.get(access_token_name);
                        clearInterval(interval);
                        broker_connect_window.close();

                        _validateBroker(executedBroker, access_token, USER_DATA.unique_identifier).then(response => {
                            if (response.status_code === 200) {
                                // Saving connected Broker info
                                localStorage.setItem("indvestment_connected_broker", JSON.stringify(response.data));

                                if (action === "REBALANCE") {
                                    navigate("rebalance", {
                                        state: {
                                            basket_data: basketData,
                                            portfolio_data: portfolioData,
                                            executed_broker: executedBroker
                                        }
                                    });
                                } else {
                                    _callGetMarketStatus(action, selected_order_item);
                                }

                            } else {
                                toast.dismiss();
                                toast.error(response.message);
                            }
                        })
                    }
                } catch (error) {
                    console.log("Cross-origin access error. Waiting for the window to navigate...");
                }

                if (broker_connect_window.closed) {
                    clearInterval(interval);
                    if (!access_token) {
                        setBtnLoader(false);
                        setRedeemLoader(false);
                        setRepairLoader(false);
                    }
                }

            }, 1000);
        }, 500);
    };

    // handle repair order - buy/sell
    const _handleRepairOrders = (selected_order_item) => {

        let repair_holding = {
            ...selected_order_item,
            "quantity": selected_order_item.unfilled_quantity,
            "portfolio_action_id": selected_order_item.portfolio_action_info?.portfolio_action_id
        }
        let action = "SINGLE_ORDER";

        if (connected_broker && isSameBroker) {
            // API call
            _callGetMarketStatus(action, repair_holding);
        } else {
            _handleConnectExecutedBroker(action, repair_holding);
        }

        setRepairLoader(true);
        setSelectedRepairOrderId(selected_order_item.alphaniti_key);
    };

    // handle cancel repair order
    const _handleCancelRepairOrder = (order_id, holding_name) => {
        // API call - cancel individual orders
        _cancelSingleRepairOrder(order_id, holding_name);
    };

    // handle close order status modal
    const _handleCloseOrderStatusModal = () => {
        setShowOrderStatusModal(false);
    };

    // handle navigate to portfolio page
    const _handleNavigatePortfolio = () => {
        navigate("/portfolio");
        setShowOrderStatusModal(false);
    };

    // handle navigate to order detail page
    const _handleNavigateOrderDetail = (portfolio_id) => {
        navigate("/orders/detail", {
            state: {
                portfolio_id
            }
        });
        setShowOrderStatusModal(false);
    };

    // ===================================== //
    // ============ API Calls ============== //

    // Get portfolio details
    const _getPortfolioDetails = async () => {

        let url = "portfolio/details";
        let data = {
            "page_num": 1,
            "tenant_id": Number(state.product.creator_id),
            "user_id": USER_DATA.unique_identifier,
            "strategy_id": state.product.strategy_id,
            "portfolio_id": state.product.portfolio_id,
            "portfolio_type": state.product.portfolio_type,
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            setPortFolioData(response.data);
            setStockBreakDown(response.data.current_holdings);
            setBreadCrumbs([...BREADCRUMBS, {
                id: 4,
                label: response.data.strategy_name,
                path: null,
            },]);

            // Checking active broker with execution broker of portfolio
            if (connected_broker) {
                setIsSameBroker(connected_broker.broker_name.toLowerCase() === response.data.execution_partner.toLowerCase());
            }

            // Finding new holdings - add to basket for buying
            let updated_holdings = response.data.holdings.map(holding => {
                let matching_holding = response.data.current_holdings.find(item => item.alphaniti_key === holding.alphaniti_key);
                if (matching_holding) {
                    return {
                        ...holding,
                        portfolio_stock_id: matching_holding.portfolio_stock_id,
                        portfolio_order_id: matching_holding.portfolio_order_id,
                        portfolio_action_id: matching_holding.portfolio_action_info?.portfolio_action_id
                    }
                } else {
                    return holding;
                }
            });

            setBasketHoldings(updated_holdings);

            // API - checking SIP is in due or not
            await _checkSIPDue(response.data);

            // Repair orders list
            let unfilled_holdings = response.data.current_holdings.filter((holding) => holding.unfilled_quantity > 0);
            setRepairHoldings(unfilled_holdings);

        } else {
            navigate(-1);
        }
        setDataLoading(false);
    };

    const _getPortfolioOrderDetail = async () => {

        let url = "portfolio/orders/detail";
        let data = {
            "user_id": USER_DATA.unique_identifier,
            "portfolio_id": state.product.portfolio_id,
            "tenant_id": Number(state.product.creator_id),
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            setOrderData(response.data.trade_data);
        } else {
            setOrderData([]);
        }

        setOrderDataLoading(false);
    };

    // Call get Market status
    const _callGetMarketStatus = async (action, selected_order_item) => {

        let connected_broker = JSON.parse(localStorage.getItem("indvestment_connected_broker"));
        const response = await _getMarketStatus();

        if (response.status_code === 200) {
            if (response.data.market_status == "Open") {
                // API => Validate connected broker
                _checkBrokerStatus(connected_broker, USER_DATA.unique_identifier).then(response => {
                    if (response.status_code === 200) {

                        // Updating connected Broker info
                        let updated_broker_data = {
                            ...connected_broker,
                            available_cash: response.data.available_cash,
                        };

                        localStorage.setItem("indvestment_connected_broker", JSON.stringify(updated_broker_data));

                        if (action === "SINGLE_ORDER") {
                            // API call
                            _callGenerateProductCode(updated_broker_data, selected_order_item);
                        } else {
                            let holdings = portfolioData.current_holdings || [];
                            if (action === "REDEEM" && holdings.length) {
                                holdings = holdings.filter((item) => item.unfilled_quantity === 0 && item.filled_quantity > 0);
                            }

                            navigate(action === "REDEEM" ? "redeem" : "/explore/strategy-detail/invest", {
                                state: {
                                    investmentType: "LUMPSUM",
                                    lumpsum: portfolioData.min_investment,
                                    portfolio_id: portfolioData.portfolio_id,
                                    basket_data: basketData,
                                    portfolio_data: portfolioData,
                                    holdings_data: action === "REDEEM" ? holdings : basketHoldings,
                                    operation: action === "REDEEM" ? "SELL_ALL" : "ADDITIONAL_PURCHASE"
                                }
                            });
                        }

                    } else {
                        if (action === "REDEEM") {
                            setRedeemLoader(true);
                        } else {
                            setBtnLoader(true);
                        }

                        // Connecting with same broker
                        _handleConnectExecutedBroker(action);
                    }
                })
            } else {
                toast.dismiss();
                toast.error("Market closed, you can't make order today");
                setRepairLoader(false);
                setSelectedRepairOrderId(null);
            }
        } else {
            toast.dismiss();
            toast.error(response.message);
            setRepairLoader(false);
            setSelectedRepairOrderId(null);
        }
        setRedeemLoader(false);
        setBtnLoader(false);

    };

    // Check SIP eligibility
    const _checkSIPDue = async (portfolio_data) => {

        let url = "portfolio/eligible-for-sip";
        let data = {
            "strategy_id": portfolio_data.strategy_id,
            "tenant_id": Number(portfolio_data.creator_info.creator_id),
            "user_id": USER_DATA.unique_identifier
        };

        let response = await APIService(url, data)
        if (response.status_code === 200) {
            setIsSIPDue(response.data.sip_flag);
        }
    };

    // Get portfolio details
    const _skipRebalance = async () => {

        setSkipLoader(true);

        let url = "portfolio/updateSkippedFlag";
        let data = {
            "user_id": USER_DATA.unique_identifier,
            "strategy_id": state.product.strategy_id,
            "portfolio_id": portfolioData.portfolio_id
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            toast.dismiss();
            toast.success("Rebalancing skipped successfully");

            // Fetching = Updated rebalance status
            _getPortfolioDetails();

        } else {
            toast.dismiss();
            toast.error(response.message);
        }

        setSkipLoader(false);
    };

    // Get portfolio details
    const _cancelSingleRepairOrder = async (order_id, holding_name) => {

        let url = "portfolio/updateOrderStatus";
        let data = {
            order_id
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            toast.dismiss();
            toast.success(holding_name + " Successfully removed from repair orders");
            // Updating orders list
            _getPortfolioDetails();
        } else {
            toast.dismiss();
            toast.error(response.message);
        }

    };


    // API calls for executing single orders - repair orders

    // ===================================== //
    // ============ API CALLS ============== //

    // handle call get Product code
    const _callGenerateProductCode = async (broker_data, order_item) => {

        let params = {
            basket_data: basketData,
            broker_data: broker_data,
            holdings: [order_item],
            // action: action,
            portfolio_id: portfolioData.portfolio_id,
            user_id: USER_DATA.unique_identifier,
            operation: order_item.portfolio_action_info.action_type
        };

        const response = await _generateProductCode(params);

        if (response.status_code === 200) {
            if (broker_data.publisher) {
                await _callOpenBrokerOrderPlatform(response.data.product_code, response.data.portfolio_action_id, broker_data, order_item);
            } else {
                // Call execute API - Manual
                await _callExecuteBrokerOrder(response.data.product_code, response.data.portfolio_action_id, broker_data, order_item);
            }
        } else {
            toast.dismiss();
            toast.error(response.message);
            setRepairLoader(false);
            setSelectedRepairOrderId(null);
        }

    };

    // handle call open broker order platform
    const _callOpenBrokerOrderPlatform = async (product_code, portfolio_action_id, broker_data, order_item) => {

        let params = {
            basket_data: basketData,
            broker_data: broker_data,
            holdings: [order_item],
            // transaction_type: action,
            portfolio_id: portfolioData.portfolio_id,
            product_code: product_code,
            user_id: USER_DATA.unique_identifier,
        };

        const response = await _openBrokerOrderPlatform(params);

        if (response.status_code === 200) {
            // Open broker order window
            const broker_window_url = URL.createObjectURL(
                new Blob([response.result], { type: "text/html" })
            );
            // Broker order creation window
            const broker_order_window = window.open(broker_window_url, "_blank");
            let current_url = "";
            let interval = setInterval(() => {
                try {
                    current_url = broker_order_window.location.href;
                    let url_data = current_url.split('?');
                    if (url_data.length !== 1) {
                        // Taking the type and action from the URL
                        let params = new URLSearchParams(url_data[1]);
                        let access_token = params.get("request_token");
                        const type = params.get("type");
                        const action = params.get("action");
                        const status = params.get("status");
                        if (type === "basket" && action === "basket" && access_token && status === "success") {
                            clearInterval(interval);
                            // API call
                            _callValidateBrokerOrder(access_token, product_code, portfolio_action_id, broker_data, order_item);
                            broker_order_window.close();
                        } else if (status === "cancelled") {
                            clearInterval(interval);
                            broker_order_window.close();
                            toast.dismiss();
                            toast.error("Order has been cancelled");
                            setRepairLoader(false);
                            setSelectedRepairOrderId(null);
                        }
                    }
                } catch (error) {
                    console.log("Cross-origin access error. Waiting for the window to navigate...");
                }

                if (broker_order_window.closed) {
                    clearInterval(interval);
                    if (current_url.length === 0) {
                        setRepairLoader(false);
                        setSelectedRepairOrderId(null);
                    }
                };

            }, 1000);

        } else {
            toast.dismiss();
            toast.error(response.message);
            setRepairLoader(false);
            setSelectedRepairOrderId(null);
        }

    };

    // handle call execute Broker Order 
    const _callExecuteBrokerOrder = async (product_code, portfolio_action_id, broker_data, order_item) => {
        let params = {
            basket_data: basketData,
            broker_data: broker_data,
            holdings: [order_item],
            product_code: product_code,
            user_id: USER_DATA.unique_identifier,
        };

        const response = await _executeBrokerOrder(params);
        if (response.status_code === 200) {
            // API 
            _callUpdatePortFolio(product_code, portfolio_action_id, broker_data, order_item);
        } else {
            toast.dismiss();
            toast.error(response.message);
            setRepairLoader(false);
            setSelectedRepairOrderId(null);
        };

    };

    // handle call validate broker order
    const _callValidateBrokerOrder = async (access_token, product_code, portfolio_action_id, broker_data, order_item) => {
        let params = {
            basket_data: basketData,
            broker_data: broker_data,
            user_id: USER_DATA.unique_identifier,
            creator_id: basketData.creator_info.creator_id,
            access_token: access_token,
        };

        const response = await _validateBrokerOrder(params);

        if (response.status_code === 200) {
            await _callUpdatePortFolio(product_code, portfolio_action_id, broker_data, order_item);
        } else {
            toast.dismiss();
            toast.error(response.message);
            setRepairLoader(false);
            setSelectedRepairOrderId(null);
        }
    };

    // handle call update portfolio
    const _callUpdatePortFolio = async (product_code, portfolio_action_id, broker_data, order_item) => {
        let params = {
            basket_data: basketData,
            broker_data: broker_data,
            user_id: USER_DATA.unique_identifier,
            product_code: product_code,
            portfolio_id: portfolioData.portfolio_id,
            investment_amount: portfolioData.investment_value,
            operation: order_item.portfolio_action_info.action_type,
            portfolio_action_id: portfolio_action_id
        };

        const response = await _createAndUpdatePortFolio(params);

        if (response.status_code === 200 || response.status_code === 202 || response.status_code === 204) {
            // Order status  = success, partial, awaiting confirmation 
            setShowOrderStatusModal(true);
            orderStatusData.current = {
                type: 1,
                status_message: response.message,
                portfolio_id: response.data.portfolio_id
            };
        } else if (response.status_code === 205) {
            // Order rejected
            setShowOrderStatusModal(true);
            orderStatusData.current = {
                type: 2,
                status_message: response.message,
            };
        } else if (response.status_code === 400) {
            // Order awaiting confirmation
            setShowOrderStatusModal(true);
            orderStatusData.current = {
                type: 2,
                status_message: response.message,
                status_code: response.status_code
            };
        } else {
            // Something went wrong
            setShowOrderStatusModal(true);
            orderStatusData.current = {
                type: 2,
                status_message: response.message,
                status_code: response.status_code
            };
        }
        setRepairLoader(false);
        setSelectedRepairOrderId(null);
    };


    return (
        <>
            {
                dataLoading ?
                    <Loader wrapperClassName="min-vh-100 margin-200px-top" />
                    :
                    <section className='pb-5'>
                        {/* Bread crumbs */}
                        <Breadcrumbs data={breadcrumbs}
                            className="padding-14px-tb px-sm-2"
                            handleNavigate={_handleNavigate} />

                        <div className={`${style.e_portfolio_detail_wrapper} border-radius-8 min-h-100vh`}>
                            {/* Top banner */}
                            <div className={`${style.e_top_section} border-radius-16 pt-4 px-3 overflow-hidden`}>
                                <div className='row justify-content-between row-gap-4 flex-lg-nowrap me-lg-4'>
                                    <div className='col-auto col-lg-6'>
                                        <div className='d-flex gap-3'>
                                            <img src={portfolioData.strategy_icon}
                                                draggable={false}
                                                className={' w-64px w-36px-res w-48px-res bg-white border-radius-8 align-self-start p-1'}
                                                alt='product' />
                                            <div className="d-flex flex-column">
                                                <div className='d-flex flex-column flex-sm-row  gap-sm-2'>
                                                    <h6 className='e-font-16-res mb-2 e-alt-font-lato e-text-white e-font-18 e-font-weight-600 line-height-24px'>
                                                        {portfolioData.strategy_name}
                                                    </h6>
                                                    <div className={`${style.e_category_chip} e-padding-4px-tb-res d-flex align-items-center padding-6px-tb px-2 gap-2 e-bg-white border-radius-24 w-max-content align-self-start`}>
                                                        <img src={require("../../Assets/Images/Card/basket-icon.svg").default}
                                                            draggable={false}
                                                            className='w-16px-res w-20px '
                                                            alt='tag' />
                                                        <span className='e-font-12-res e-alt-font-lato e-text-chinese-black e-font-14 e-font-weight-600 line-height-20px'>
                                                            {"alphaBasket"}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div>
                                                    <span className='e-text-pale-lavender e-font-14-res e-alt-font-lato e-font-16 e-font-weight-400 line-height-18px pe-1 '>
                                                        Creator:
                                                    </span>
                                                    <span className='e-text-white e-font-14-res e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px'>
                                                        {portfolioData.creator_name}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-auto col-lg-auto'>
                                        <div className='d-flex justify-content-between flex-wrap gap-4 gap-sm-5'>
                                            <div className='col-auto'>
                                                <p className='mb-1 e-alt-font-lato e-text-lavender-light e-font-14 e-font-weight-500 line-height-18px'>
                                                    Risk type
                                                </p>
                                                <Chip label={portfolioData.risk_category_info.risk_category_name}
                                                    className={portfolioData.risk_category_info.risk_category_name === 'Conservative' ? 'e-text-deep-green e-bg-nyanza e-border-1px-light-green' :
                                                        portfolioData.risk_category_info.risk_category_name === 'Moderate' ? 'e-text-brown e-bg-lemon-chiffon e-border-1px-jasmine' :
                                                            'e-text-cadmium-purple e-bg-lavender-blush e-border-1px-light-red'} />
                                            </div>
                                            <div className='col-auto'>
                                                <p className='mb-1 e-alt-font-lato e-text-lavender-light e-font-14 e-font-weight-500 line-height-18px'>
                                                    First invested on
                                                </p>
                                                <p className='mb-0 e-alt-font-lato e-text-white e-font-16 e-font-weight-600 line-height-20px'>
                                                    {portfolioData.created_on}
                                                </p>
                                            </div>
                                            <div className='col-auto'>
                                                <p className='mb-1 e-alt-font-lato e-text-lavender-light e-font-14 e-font-weight-500 line-height-18px'>
                                                    Last invested on
                                                </p>
                                                <p className='mb-0 e-alt-font-lato e-text-white e-font-16 e-font-weight-600 line-height-20px'>
                                                    {portfolioData.updated_on}
                                                </p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="e-border-bottom-1px-lavender-light-pink margin-20px-tb"></div>
                                <div className='row flex-wrap g-3 pb-4'>
                                    {/* Current Value and Invested Amount */}
                                    <div className="col-12 col-sm-auto">
                                        <div className={`${style.e_amount_wrapper} d-flex gap-0px-res justify-content-between align-items-center gap-64px px-4 padding-20px-tb border-radius-8`}>
                                            <div>
                                                <p className='mb-1 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                                    Current Value
                                                </p>
                                                <p className='e-font-16-res mb-0 e-text-primary-color e-alt-font-lato e-font-18 e-font-weight-600 line-height-24px'>
                                                    ₹{portfolioData.current_value.toLocaleString("en-In")}
                                                    {/* <span className={`${Number(portfolioData.returns_per) >= 0 ? "e-text-islamic-green" : "e-text-red"} e-font-16 ps-1`}>({portfolioData.returns_per}%)</span> */}
                                                </p>
                                            </div>
                                            <div>
                                                <p className='mb-1 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                                    Invested Amount
                                                </p>
                                                <p className='e-font-16-res mb-0 e-text-primary-color e-alt-font-lato e-font-18 e-font-weight-600 line-height-24px'>
                                                    ₹{portfolioData.investment_value.toLocaleString("en-In")}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Total Returns */}
                                    {/* <div className='col-6 col-sm-auto'>
                                        <div className={`e-bg-dutch-white d-flex flex-column gap-1 py-3 ps-3 pe-3 pe-lg-5 border-radius-8`}>
                                            <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px'>
                                                Today’s Returns
                                            </p>
                                            <p className='e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-24px'>
                                                ₹16,29,220.50 <span className='e-font-12 e-text-islamic-green line-height-20px'>(12.45%)</span>
                                            </p>
                                        </div>
                                    </div> */}

                                    {/* XIRR's Returns  */}
                                    <div className='col-6 col-sm-auto'>
                                        <div className={`${style.e_today_returns_wrapper} d-flex flex-column gap-1 px-4 padding-20px-tb  border-radius-8 h-100`}>
                                            <p className='mb-0 e-text-white e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                                {portfolioData.returns_data.label}
                                            </p>
                                            <div className='d-flex gap-1 align-items-center'>
                                                <Icon icon={portfolioData.returns_data.value >= 0 ? "returns-up" : "returns-down"}
                                                    className="d-flex"
                                                    size="20" />
                                                <p className={`${portfolioData.returns_data.value >= 0 ? "e-text-islamic-green" : "e-text-red"}  e-font-14-res mb-0 e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px`}>
                                                    {portfolioData.returns_data.value_str}
                                                    {
                                                        portfolioData.returns_data.label === "Returns" &&
                                                        <span className="e-font-12 line-height-20px">
                                                            (₹{Number(portfolioData.unrealized_profit_loss_value).toLocaleString("en-IN")})
                                                        </span>
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Custom tab */}
                                <div className='d-flex gap-32px padding-2px-top ps-2'>
                                    {TAB_DATA.map((tab, key) => (
                                        <div key={key}>
                                            <CustomTab tabIndex={tabIndex}
                                                data={tab}
                                                handleClick={_handleTabChange} />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className='py-3 px-3'>
                                <div className='row row-gap-4'>
                                    <div className={portfolioData.sip && portfolioData.sip_details ? "col-12 col-lg-8" : "col-12 col-lg-8"}>
                                        {tabIndex === 1 ?
                                            <>
                                                {/*  Re-balance Card */}
                                                {
                                                    portfolioData.eligible_for_rebalancing && portfolioData.subscription_status === "ACTIVE" && repairHoldings.length === 0 &&
                                                    <div className={`${style.e_new_rebalance_wrapper} border-radius-16`}>
                                                        <div className={`${style.e_new_rebalance_card} border-radius-16`}>
                                                            <div className='row'>
                                                                <div className='col-12 col-sm-8'>
                                                                    <div className='p-3'>
                                                                        <h6 className='mb-3 e-primary-font-clash-display e-text-primary-color e-font-16 e-font-weight-600 line-height-20px'>
                                                                            New Rebalance Available
                                                                        </h6>

                                                                        <div className='d-flex gap-0px-res justify-content-between gap-80px'>
                                                                            <div>
                                                                                <p className='mb-1 e-alt-font-lato e-text-outer-space e-font-14 e-font-weight-400 line-height-18px'>
                                                                                    Triggered on
                                                                                </p>
                                                                                <p className='mb-0 e-alt-font-lato e-text-chinese-black e-font-14 e-font-weight-600 line-height-20px'>
                                                                                    {portfolioData.updated_on || "--"}
                                                                                </p>
                                                                            </div>

                                                                        </div>

                                                                        <div className="d-flex gap-3 align-items-center margin-18px-top">


                                                                            <TextButton name="View details & rebalance"
                                                                                type={3}
                                                                                className={`${basketData.strategy_id ? "" : "pe-none"}  w-max-content`}
                                                                                icon={true}
                                                                                onPress={_handleNavigateToRebalanceDetails} />
                                                                            <PrimaryButton name={"Skip"}
                                                                                className={"px-3 py-2 h-34 w-80px d-flex align-items-center justify-content-center"}
                                                                                status={skipLoader}
                                                                                onPress={_handleSkipRebalance} />
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className='col-4 d-none d-sm-block'>
                                                                    <img src={require("../../Assets/Images/Portfolio/new-rebalance-img.png")}
                                                                        draggable={false}
                                                                        height={148}
                                                                        className='w-100 object-fit-contain' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                {/* Repair orders */}
                                                {
                                                    repairHoldings.length !== 0 &&
                                                    <div className={`pt-3`}>
                                                        <h6 className='e-primary-font-clash-display e-text-chinese-black e-font-16 e-font-weight-500 line-height-24px mb-1 '>
                                                            Repair Orders
                                                        </h6>
                                                        <p className='e-alt-font-lato e-text-outer-space e-font-14 e-font-weight-400 line-height-20px mb-2'>
                                                            Repair orders are those orders that have previously failed and require action from your side.
                                                        </p>

                                                        <div className='overflow-scroll no-scrollbar border-radius-16 e-gradient-bg-orders'>
                                                            <div className='e-bg-magnolia px-3 padding-10px-tb width-500px-res width-600px-res-md'>
                                                                <div className='row flex-nowrap'>
                                                                    <div className='col-7'>
                                                                        <h6 className='mb-0 e-text-black e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px cursor-pointer'>
                                                                            {portfolioData.current_holdings.length === 1 ? "Stock" : "Stocks"} ({portfolioData.current_holdings.length})
                                                                        </h6>
                                                                    </div>
                                                                    <div className='col-3 text-center'>
                                                                        <h6 className='mb-0 e-text-black e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px'>
                                                                            Quantity
                                                                        </h6>
                                                                    </div>
                                                                    <div className='col-2'>
                                                                        <h6 className='mb-0 e-text-black e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px'>
                                                                            Action
                                                                        </h6>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Added stocks */}
                                                            <div className='px-3  width-500px-res width-600px-res-md bg-white border-radius-blr-16'>
                                                                {
                                                                    repairHoldings.map((item, index) => (
                                                                        <div className='row flex-nowrap e-border-bottom-1px-anti-flash-white py-2 align-items-center'
                                                                            key={index}>
                                                                            <div className='col-7'>
                                                                                <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                                                                                    {item.holding_name}
                                                                                </p>
                                                                                <p className='mb-1 e-text-slate-gray e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                                                                                    {item.nse_exchange_symbol || item.bse_exchange_symbol}
                                                                                </p>
                                                                            </div>
                                                                            <div className='col-3 text-center'>
                                                                                <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                                                                    {item.unfilled_quantity}
                                                                                </p>
                                                                            </div>
                                                                            <div className='col-2'>
                                                                                <div className="d-flex align-items-center gap-3">
                                                                                    <PrimaryButton name={item.action === "BUY" ? "Buy" : "Sell"}
                                                                                        status={repairLoader && item.alphaniti_key === selectedRepairOrderId}
                                                                                        disabled={repairLoader}
                                                                                        loaderSize={16}
                                                                                        className={`${item.action === "SELL" ? "e-bg-vermilion" : ""} py-1 w-56px h-28 d-flex align-items-center justify-content-center`}
                                                                                        onPress={() => _handleRepairOrders(item)} />
                                                                                    <Icon icon={"failed-icon"}
                                                                                        className="d-flex cursor-pointer"
                                                                                        size="20"
                                                                                        onClick={() => _handleCancelRepairOrder(item.portfolio_order_id, item.holding_name)} />
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                {/* Stock Breakdown */}
                                                <div className={`pt-3`}>
                                                    <h6 className='mb-2 e-primary-font-clash-display e-text-chinese-black e-font-16 e-font-weight-500 line-height-24px'>
                                                        Stock Breakdown
                                                    </h6>

                                                    <div className='overflow-scroll no-scrollbar'>
                                                        <div className='e-bg-magnolia px-3 padding-10px-tb width-500px-res width-600px-res-md'>
                                                            <div className='row flex-nowrap'>
                                                                <div className='col-5'>
                                                                    <h6 className='mb-0 e-text-black e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px cursor-pointer'>
                                                                        {portfolioData.current_holdings.length === 1 ? "Stock" : "Stocks"} ({portfolioData.current_holdings.length})
                                                                    </h6>
                                                                </div>
                                                                <div className='col-2 text-center'>
                                                                    <h6 className='mb-0 e-text-black e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px'>
                                                                        Weight
                                                                    </h6>
                                                                </div>
                                                                <div className='col-3 col-sm-2 text-sm-end text-center'>
                                                                    <h6 className='text-nowrap text-sm-wrap gap-1 mb-0 e-text-black e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px'
                                                                        onClick={_handleSortByInvestedValue}>
                                                                        Invested value
                                                                        <Icon icon="sort-icon" size={12} className="ms-1" />
                                                                    </h6>
                                                                </div>
                                                                <div className='col-3 text-sm-end text-center'>
                                                                    <h6 className='text-nowrap text-sm-wrap mb-0 e-text-black e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px cursor-pointer'
                                                                        onClick={_handleSortByCurrentValue}>
                                                                        Current value
                                                                        <Icon icon="sort-icon" size={12} className="ms-1" />
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Added stocks */}
                                                        <div className='px-3  width-500px-res width-600px-res-md'>
                                                            {
                                                                stockBreakDown.map((item, index) => (
                                                                    <div className='row flex-nowrap e-border-bottom-1px-anti-flash-white py-2 align-items-center'
                                                                        key={index}>
                                                                        <div className='col-5'>
                                                                            <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-400 line-height-20px'>
                                                                                {item.holding_name}
                                                                            </p>

                                                                            <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-12 e-font-weight-400 line-height-20px'>
                                                                                Quantity: <span className='e-text-primary-color e-font-weight-600'>{item.quantity}</span>
                                                                            </p>
                                                                        </div>
                                                                        <div className='col-2 text-center'>
                                                                            <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                                                                {item.weight.toFixed(2)}%
                                                                            </p>
                                                                        </div>
                                                                        <div className='col-3 col-sm-2 text-sm-end text-center'>
                                                                            <p className='margin-2px-bottom e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                                                                {_formattedAmount(item.invested_amount)}
                                                                            </p>
                                                                        </div>
                                                                        <div className='col-3 text-sm-end text-center'>
                                                                            <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                                                                {_formattedAmount(item.current_value)}
                                                                                <span className={`${item.returns < 0 ? "e-text-red" : "e-text-islamic-green"} ps-1 e-font-12`}>
                                                                                    ( {isNaN(item.returns) ? "0" : item.returns.toFixed(2)}%)
                                                                                </span>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>

                                                        {/* Total Amount */}
                                                        <div className='px-3 padding-18px-tb width-500px-res'>
                                                            <div className='row flex-nowrap'>
                                                                <div className='col-5'>
                                                                    <h6 className='e-font-14-res  mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                                                        Total Amount
                                                                    </h6>
                                                                </div>
                                                                <div className='col-2 text-center'>
                                                                    <h6 className='e-font-14-res  mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-24px'>
                                                                        100%
                                                                    </h6>
                                                                </div>
                                                                <div className='col-3 col-sm-2 text-sm-end text-center'>
                                                                    <h6 className='e-font-14-res  mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-24px'>
                                                                        {_formattedAmount(portfolioData.current_holdings.reduce((initial, b) => initial + b.invested_amount, 0))}
                                                                    </h6>
                                                                </div>
                                                                <div className='col-3 text-sm-end text-center'>
                                                                    <h6 className='e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-24px'>
                                                                        {_formattedAmount(portfolioData.current_holdings.reduce((initial, b) => initial + Number(b.current_value), 0))}
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            // Order history 
                                            <>
                                                <h6 className='mb-2 e-primary-font-clash-display e-text-chinese-black e-font-16 e-font-weight-500 line-height-24px'>
                                                    Order History
                                                </h6>

                                                {
                                                    orderDataLoading === false ?
                                                        <div className="d-flex flex-column gap-3">
                                                            {
                                                                orderData.map((item, index) => (
                                                                    <div key={index}
                                                                        className="e-border-1px-anti-flash-white border-radius-8 pt-3 cursor-pointer mb-4">
                                                                        {/* Order summary section */}
                                                                        <div className="px-3 e-bg-primary-color" onClick={() => _handleShowStockDetails(index)}>
                                                                            <div className="d-flex justify-content-between">
                                                                                <div className='col-auto'>
                                                                                    <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                                                                        Traded on
                                                                                    </p>
                                                                                    <p className={`e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-20px e-letter-spacing-min-point-1px`}>
                                                                                        {item.traded_on}
                                                                                    </p>
                                                                                </div>
                                                                                <div className='col-auto'>
                                                                                    <div className="d-flex justify-content-between gap-3">
                                                                                        <div>
                                                                                            <p className='mb-1 e-text-outer-space e-alt-font-lato e-font-14 e-font-weight-400 line-height-18px'>
                                                                                                Order Status
                                                                                            </p>
                                                                                            <p className={`d-flex gap-1 align-items-center mb-0 e-alt-font-lato e-font-16 e-font-weight-600 line-height-16px
                                                                                                ${item.order_status === "Success" ? "e-text-go-green" : (item.order_status === "Partially Completed" || item.order_status === "Pending") ? "e-text-marigold" : "e-text-paradise-pink"}`}>
                                                                                                <Icon icon={item.order_status === "Success" ? "success-icon" : (item.order_status === "Partially Completed" || item.order_status === "Pending") ? "processing-icon" : "failed-icon"}
                                                                                                    size={18} />
                                                                                                {item.order_status}
                                                                                            </p>
                                                                                        </div>
                                                                                        <div className="align-self-end">
                                                                                            <span className="e-bg-magnolia-light rounded-5 px-1 cursor-pointer"
                                                                                                onClick={() => _handleShowStockDetails(index)}>
                                                                                                <Icon icon="drop-down-icon"
                                                                                                    className={`${expandedKey === index ? "e-rotate-180" : ""} mb-1 transition`}
                                                                                                    size={12} />
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className={`mt-3 ${expandedKey !== index ? "h-0 overflow-hidden" : ""}`}>
                                                                            <div>
                                                                                <div className="d-flex py-2">
                                                                                    <div className="ps-3 col-3 py-2 e-bg-magnolia-light">
                                                                                        <span className="e-text-black e-alt-font-lato e-font-weight-600 e-font-12 line-height-20px">
                                                                                            {item.trade_info.length === 1 ? "Stock" : `Stocks(${item.trade_info.length})`}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="col-3 col-sm-2  text-center py-2 e-bg-magnolia-light">
                                                                                        <span className="e-text-black e-alt-font-lato e-font-weight-600 e-font-12 line-height-20px">
                                                                                            Quantity
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="col-4 col-sm-2  text-center py-2 e-bg-magnolia-light">
                                                                                        <span className="e-text-black e-alt-font-lato e-font-weight-600 e-font-12 line-height-20px">
                                                                                            Price
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="col-4 col-sm-2  text-center py-2 e-bg-magnolia-light">
                                                                                        <span className="e-text-black e-alt-font-lato e-font-weight-600 e-font-12 line-height-20px">
                                                                                            Type
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="col-3 text-center py-2 e-bg-magnolia-light">
                                                                                        <span className="e-text-black e-alt-font-lato e-font-weight-600 e-font-12 line-height-20px">
                                                                                            Status
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                {
                                                                                    item.trade_info.map((order_item, index) => (
                                                                                        <div key={index}>
                                                                                            <div className="d-flex py-2 align-items-center">
                                                                                                <div className="ps-3 col-3">
                                                                                                    <span className="d-flex flex-column e-text-chinese-black e-alt-font-lato e-font-weight-400 e-font-14 line-height-20px">
                                                                                                        {order_item.script_name}
                                                                                                    </span>
                                                                                                </div>
                                                                                                <div className="col-3 col-sm-2 text-center">
                                                                                                    <span className="e-text-chinese-black e-alt-font-lato e-font-weight-600 e-font-14 line-height-20px e-letter-spacing-min-point-1px">
                                                                                                        {order_item.quantity}
                                                                                                    </span>
                                                                                                </div>
                                                                                                <div className="col-4 col-sm-2  text-center">
                                                                                                    <span className="e-text-chinese-black e-alt-font-lato e-font-weight-600 e-font-14 line-height-20px e-letter-spacing-min-point-1px">
                                                                                                        {_formattedAmount(order_item.purchase_price)}
                                                                                                    </span>
                                                                                                </div>
                                                                                                <div className="col-4 col-sm-2 text-center">
                                                                                                    <span className={`${order_item.action === "BUY" ? "e-text-primary-color" : "e-text-paradise-pink"}  e-alt-font-lato e-font-weight-600 e-font-12 line-height-20px e-letter-spacing-min-point-1px`}>
                                                                                                        {order_item.action}
                                                                                                    </span>
                                                                                                </div>
                                                                                                <div className="col-3 text-center">
                                                                                                    <span className={`d-flex gap-1 align-items-center justify-content-center mb-0 e-alt-font-lato e-font-12 e-font-weight-600 line-height-16px
                                                                                                        ${order_item.status === "COMPLETE" ? "e-text-go-green" : order_item.status === "PENDING" ? "e-text-marigold" : "e-text-paradise-pink"}`}>
                                                                                                        <Icon icon={order_item.status === "COMPLETE" ? "success-icon" : order_item.status === "PENDING" ? "processing-icon" : "failed-icon"}
                                                                                                            size={18} />
                                                                                                        {order_item.status}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <hr className="mx-3 my-0 e-text-anti-flash-white opacity-100 width-100" />
                                                                                        </div>

                                                                                    ))
                                                                                }
                                                                                <div className="d-flex  py-2 mt-2">
                                                                                    <div className="ps-3 col-3">
                                                                                        <span className="e-text-chinese-black e-alt-font-lato e-font-weight-600 e-font-14 line-height-20px e-letter-spacing-min-point-1px">
                                                                                            Total
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="col-3 col-sm-2 text-center">
                                                                                        <span className="e-font-14-res e-text-chinese-black e-alt-font-lato e-font-weight-600 e-font-16 line-height-20px e-letter-spacing-min-point-1px">
                                                                                            {
                                                                                                item.trade_info.map(item => Number(item.quantity)).reduce((a, b) => a + b, 0)
                                                                                            }
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="col-4 col-sm-2 text-center">
                                                                                        <span className="e-font-14-res e-text-chinese-black e-alt-font-lato e-font-weight-600 e-font-16 line-height-20px e-letter-spacing-min-point-1px">
                                                                                            {
                                                                                                _formattedAmount(item.trade_info.map(item => Number(item.purchase_price)).reduce((a, b) => a + b, 0))
                                                                                            }
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>

                                                        :
                                                        <Loader wrapperClassName="margin-100px-top" />
                                                }


                                            </>
                                        }
                                    </div>

                                    {/* SIP and Invest more section */}
                                    <div className='col col-md-8 col-lg-4'>
                                        <div className={`${style.e_active_sip_wrapper} p-3 border-radius-16 e-border-1px-lavender-light position-sticky top-0`}>

                                            {
                                                portfolioData.sip_details &&
                                                <>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <h6 className='e-font-14-res mb-0 e-primary-font-clash-display e-text-chinese-black e-font-16 e-font-weight-500 line-height-20px'>
                                                            Active SIP
                                                        </h6>
                                                        <TextButton name="Manage SIPs"
                                                            type={3}
                                                            icon={true}
                                                            onPress={_handleManageSIP} />
                                                    </div>

                                                    <div className={`${style.e_sip_amount_wrapper} mt-3 border-radius-16`}>
                                                        <div className='e-bg-white border-radius-16 padding-12px-tb px-3'>
                                                            <div className='row'>
                                                                {/* Amount & Start Date */}
                                                                <div className='col-8'>
                                                                    <p className='mb-2 e-alt-font-lato e-text-chinese-black e-font-12 e-font-weight-600 line-height-20px'>
                                                                        Amount & Start Date
                                                                    </p>
                                                                    <p className='e-font-14-res mb-1 e-primary-font-clash-display e-text-primary-color e-font-18 e-font-weight-500 line-height-24px'>
                                                                        ₹{portfolioData.sip_details.amount.toLocaleString("en-IN")}
                                                                    </p>
                                                                    <p className='mb-2 e-alt-font-lato e-text-charleston-green e-font-12 e-font-weight-400 line-height-18px'>
                                                                        {portfolioData.sip_details.created_on}
                                                                    </p>
                                                                </div>

                                                                {/* Upcoming SIP */}
                                                                {
                                                                    portfolioData.sip_details.next_sip_date &&
                                                                    <div className='col-4 text-center'>
                                                                        <p className='mb-2 e-alt-font-lato e-text-chinese-black e-font-12 e-font-weight-600 line-height-20px'>
                                                                            Upcoming SIP
                                                                        </p>

                                                                        <div className='d-flex justify-content-center '>
                                                                            <div className={`${style.e_upcoming_date_wrapper} w-max-content e-border-1px-bright-gray-light border-radius-12 padding-12px-lr py-1`}>
                                                                                <p className='mb-0 e-primary-font-clash-display e-text-primary-color e-font-16 e-font-weight-500 line-height-24px'>
                                                                                    {portfolioData.sip_details.next_sip_date && portfolioData.sip_details.next_sip_date.split(" ")[1]}
                                                                                </p>
                                                                                <p className='mb-0 e-alt-font-lato e-text-chinese-black e-font-12 e-font-weight-400 line-height-18px'>
                                                                                    {portfolioData.sip_details.next_sip_date && portfolioData.sip_details.next_sip_date.split(" ")[0]}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            }

                                            {/* Custom buttons */}
                                            <div className='d-flex gap-2 flex-column pt-4'>
                                                {
                                                    portfolioData.subscription_status === "ACTIVE" && isSIPDue === false &&
                                                    <PrimaryButton name="Invest More"
                                                        padding="padding-18px-tb e-padding-8px-tb-res"
                                                        fontSize="e-font-14-res e-font-16"
                                                        className="w-100 h-54"
                                                        status={btnLoader}
                                                        disabled={btnLoader || basketData.strategy_id == null || repairHoldings.length !== 0}
                                                        onPress={_handleNavigateToInvest} />
                                                }
                                                <SecondaryButton name="Redeem"
                                                    status={redeemLoader}
                                                    disabled={redeemLoader}
                                                    fontSize="e-font-14-res e-font-16"
                                                    padding="padding-18px-tb e-padding-8px-tb-res "
                                                    className="w-100 h-54"
                                                    onPress={_handleNavigateToRedeem} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
            }



            {/* Order status modal */}
            {
                showOrderStatusModal &&
                <OrderStatusModal type={orderStatusData.current.type}
                    portfolioType={1}
                    action={orderStatusData.current.status_code == 400 ? "ORDER_SUCCESS" : ""}
                    statusMessage={orderStatusData.current.status_message}
                    portfolioId={orderStatusData.current.portfolio_id}
                    handleClose={_handleCloseOrderStatusModal}
                    handleNavigatePortfolio={_handleNavigatePortfolio}
                    handleNavigateOrderDetail={_handleNavigateOrderDetail} />
            }
        </>
    )
};

export default PortfolioDetail;
